import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { employeesKeys } from 'src/features/employees/api/query-keys/employees';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { inviteEmployee } from '../../api/lib/employees';
import { getInviteEmployeeErrorTranslation } from '../../utils/get-invite-employee-error-translation';

export const useInviteEmployee = (onSuccess?: () => void) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (email: string) => inviteEmployee(email),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: employeesKeys.lists(),
        });
      });
      toast.success(t('employees:employees.inviteEmployeeDialog.success'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(t(getInviteEmployeeErrorTranslation(error)));
    },
  });
};
